<template>
  <el-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="选择特殊物料标签模板"
      width="80%"
      top="5vh">
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        hide-show-hide-btn
        url="repairRegistrations/page">
      <template #adSearch>
        <vm-search label="单据编号">
          <el-input v-model="filter.billNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="检测报告">
          <el-select
              v-model="filter.reported"
              placeholder="请选择"
              clearable>
            <el-option :value="true" label="有"/>
            <el-option :value="false" label="无"/>
          </el-select>
        </vm-search>
        <vm-search label="维修员">
          <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="维修类型">
          <el-select v-model="filter.afterSaleType" placeholder="请选择" clearable>
            <el-option value="更换"/>
            <el-option value="维修"/>
            <el-option value="回采"/>
            <el-option value="批量整改"/>
          </el-select>
        </vm-search>
        <vm-search label="售后单号" :value-width="110">
          <el-input v-model="filter.afterSaleOrderNos" type="textarea" autosize placeholder="支持输入多行"/>
        </vm-search>
        <vm-search label="质量异常单号">
          <el-input v-model.trim="filter.qualityRegistrationNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="事业部">
          <el-select v-model="filter.department" placeholder="请选择" clearable>
            <el-option value="电气"/>
            <el-option value="电机"/>
            <el-option value="运控"/>
            <el-option value="机器人"/>
            <el-option value="杭州之山"/>
            <el-option value="其他"/>
          </el-select>
        </vm-search>
        <vm-search label="需求节点">
          <el-select v-model="filter.demandNode" placeholder="请选择" clearable>
            <el-option value="售后"/>
            <el-option value="生产"/>
            <el-option value="拆解部件"/>
            <el-option value="OEM厂内组装"/>
            <el-option value="OEM厂内负载"/>
            <el-option value="OEM厂内包装"/>
            <el-option value="OEM厂内物流"/>
            <el-option value="OEM厂内SMT"/>
            <el-option value="外协工厂"/>
            <el-option value="研发"/>
          </el-select>
        </vm-search>
        <vm-search label="部件类型">
          <el-select v-model="filter.partType" placeholder="请选择" clearable>
            <el-option value="整机"/>
            <el-option value="板卡"/>
            <el-option value="抱闸电源"/>
            <el-option value="操作器"/>
            <el-option value="IGBT模块"/>
            <el-option value="电容"/>
            <el-option value="电流传感器"/>
            <el-option value="线束"/>
            <el-option value="电子元件"/>
            <el-option value="其它器件"/>
            <el-option value="其它"/>
          </el-select>
        </vm-search>
        <vm-search label="客户名称">
          <el-input v-model.trim="filter.customerName" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="外部客户名称">
          <el-input v-model.trim="filter.outerCustomer" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="客户单号">
          <el-input v-model.trim="filter.customerOrderNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="申请部件条码" :value-width="150">
          <el-input v-model.trim="filter.demandSn" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="申请物料号">
          <el-input v-model.trim="filter.demandMaterialNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="实收序列号" :value-width="150">
          <el-input v-model.trim="filter.receiveSn" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="实收物料号">
          <el-input v-model.trim="filter.receiveMaterialNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="规格型号">
          <el-input v-model.trim="filter.model" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="模块品牌">
          <el-input v-model.trim="filter.moduleBranding" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="原部件条码" :value-width="150">
          <el-input v-model.trim="filter.originPartSn" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="部件条码" :value-width="150">
          <el-input v-model.trim="filter.partSn" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="型号">
          <el-input v-model.trim="filter.partModel" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="元件物料号">
          <el-input v-model.trim="filter.componentMaterialNo" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="维修状态">
          <el-input v-model.trim="filter.repairStatus" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search-date
            label="维修日期"
            :start-time.sync="filter.startTime"
            :end-time.sync="filter.endTime"/>
        <vm-search-date
            label="预计发货日期"
            :start-time.sync="filter.expiredDeliveryDateStart"
            :end-time.sync="filter.expiredDeliveryDateEnd"/>
        <vm-search label="新条码号" :value-width="150">
          <el-input v-model.trim="filter.newMachineSn" placeholder="请输入" clearable/>
        </vm-search>
        <vm-search label="新物料号">
          <el-input v-model.trim="filter.newMaterialNo" placeholder="请输入" clearable/>
        </vm-search>
      </template>
      <el-table-column prop="billNo" label="单据编号" align="center" width="80px">
        <template #header>
          <el-input v-model.trim="filter.billNo" placeholder="单据编号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="reported" label="检测报告" align="center" width="80px">
        <template v-slot="scope">
          <el-tag v-if="scope.row.reported" type="success">有</el-tag>
          <el-tag v-else type="info">无</el-tag>
        </template>
        <template #header>
          <el-select
              v-model="filter.reported"
              placeholder="检测报告"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option :value="true" label="有"/>
            <el-option :value="false" label="无"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="creatorName" label="维修员" align="center" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.creatorName" placeholder="维修员" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="afterSaleType" label="维修类型" align="center" show-overflow-tooltip>
        <template #header>
          <el-select
              v-model="filter.afterSaleType"
              placeholder="维修类型"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="更换"/>
            <el-option value="维修"/>
            <el-option value="回采"/>
            <el-option value="批量整改"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="afterSaleOrderNo"
          label="售后单号"
          align="center"
          width="110px"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.afterSaleOrderNo" placeholder="售后单号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="qualityRegistrationNo"
          label="质量异常单号"
          align="center"
          width="120px"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.qualityRegistrationNo" placeholder="质量异常单号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="department" label="事业部" align="center" show-overflow-tooltip>
        <template #header>
          <el-select
              v-model="filter.department"
              placeholder="事业部"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="电气"/>
            <el-option value="电机"/>
            <el-option value="运控"/>
            <el-option value="机器人"/>
            <el-option value="杭州之山"/>
            <el-option value="其他"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="demandNode"
          label="需求节点"
          align="center"
          width="110px"
          show-overflow-tooltip>
        <template #header>
          <el-select
              v-model="filter.demandNode"
              placeholder="需求节点"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="售后"/>
            <el-option value="生产"/>
            <el-option value="拆解部件"/>
            <el-option value="OEM厂内组装"/>
            <el-option value="OEM厂内负载"/>
            <el-option value="OEM厂内包装"/>
            <el-option value="OEM厂内物流"/>
            <el-option value="OEM厂内SMT"/>
            <el-option value="外协工厂"/>
            <el-option value="研发"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="partType" label="部件类型" align="center" show-overflow-tooltip>
        <template #header>
          <el-select
              v-model="filter.partType"
              placeholder="部件类型"
              clearable
              @change="$refs.vmTable.handleSearchClick()">
            <el-option value="整机"/>
            <el-option value="板卡"/>
            <el-option value="抱闸电源"/>
            <el-option value="操作器"/>
            <el-option value="IGBT模块"/>
            <el-option value="电容"/>
            <el-option value="电流传感器"/>
            <el-option value="线束"/>
            <el-option value="电子元件"/>
            <el-option value="其它器件"/>
            <el-option value="其它"/>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
          prop="customerName"
          label="客户名称"
          align="center"
          width="160px"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.customerName" placeholder="客户名称" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="outerCustomer"
          label="外部客户名称"
          align="center"
          width="100"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.outerCustomer" placeholder="外部客户名称" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="customerOrderNo" label="客户单号" align="center" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.customerOrderNo" placeholder="客户单号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="demandSn"
          label="申请部件条码"
          align="center"
          width="160px"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.demandSn" placeholder="申请部件条码" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="demandMaterialNo" label="申请物料号" align="center" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.demandMaterialNo" placeholder="申请物料号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="demandMaterialName" label="申请物料描述" show-overflow-tooltip/>
      <el-table-column
          prop="quantity"
          label="数量"
          align="center"
          width="60px"
          show-overflow-tooltip/>
      <el-table-column
          prop="productDate"
          label="生产日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="deliveryDate"
          label="发货时间"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="demandAfterSaleTime"
          label="售后申请时间"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column prop="saleTime" label="售出时长/月" align="center" show-overflow-tooltip/>
      <el-table-column prop="afterSaleExpired" label="售后过保" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.afterSaleExpired === true">是</span>
          <span v-if="scope.row.afterSaleExpired === false">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="needQualitySurvey" label="需要质量报告" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.needQualitySurvey === true">是</span>
          <span v-if="scope.row.needQualitySurvey === false">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="siteDesc" label="现场描述" show-overflow-tooltip/>
      <el-table-column
          prop="receiveSn"
          label="实收序列号"
          align="center"
          width="160px"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.receiveSn" placeholder="实收序列号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="receiveMaterialNo" label="实收物料号" align="center" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.receiveMaterialNo" placeholder="实收物料号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="receiveMaterialName" label="实收物料描述" show-overflow-tooltip/>
      <el-table-column prop="model" label="规格型号" align="center" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.model" placeholder="规格型号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="machinePlatform" label="整机平台" align="center" show-overflow-tooltip/>
      <el-table-column prop="voltageLevel" label="电压等级" align="center" show-overflow-tooltip/>
      <el-table-column prop="power" label="功率" align="center" show-overflow-tooltip/>
      <el-table-column
          prop="receiveProductDate"
          label="实收生产日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="receiveDeliveryDate"
          label="实收发货日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="receiveSaleTime"
          label="实收售出时长/月"
          width="110px"
          align="center"
          show-overflow-tooltip/>
      <el-table-column prop="receiveAfterSaleExpired" label="实收售后过保" align="center">
        <template v-slot="scope">
          <span v-if="scope.row.receiveAfterSaleExpired === true">是</span>
          <span v-if="scope.row.receiveAfterSaleExpired === false">否</span>
        </template>
      </el-table-column>
      <el-table-column prop="pgCard" label="PG卡" align="center" show-overflow-tooltip/>
      <el-table-column prop="powerOnTime" label="上电时间" align="center" show-overflow-tooltip/>
      <el-table-column prop="runTime" label="运行时间" align="center" show-overflow-tooltip/>
      <el-table-column prop="radiatorTemperature" label="散热器温度" align="center" show-overflow-tooltip/>
      <el-table-column prop="faultCode" label="故障代码" align="center" show-overflow-tooltip/>
      <el-table-column prop="moduleBranding" label="模块品牌" align="center" show-overflow-tooltip/>
      <el-table-column prop="originProgram" label="原程序" align="center" show-overflow-tooltip/>
      <el-table-column prop="newProgram" label="新程序" align="center" show-overflow-tooltip/>
      <el-table-column prop="missingParts" label="缺件信息" align="center" show-overflow-tooltip/>
      <el-table-column prop="inspectionResult" label="检测结果" align="center" show-overflow-tooltip/>
      <el-table-column prop="solution" label="处理方法" align="center" show-overflow-tooltip/>
      <el-table-column prop="faultType" label="故障模块分类" align="center" show-overflow-tooltip/>
      <el-table-column prop="causeInvestigation" label="原因分析" align="center" show-overflow-tooltip/>
      <el-table-column prop="responsibleDecision" label="责任判定" align="center" show-overflow-tooltip/>
      <el-table-column prop="reasonForCharge" label="收费原因" align="center" show-overflow-tooltip/>
      <el-table-column prop="partCosts" label="部件费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="materialCosts" label="材料费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="otherCosts" label="其他费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="laborTime" label="工时/分钟" align="center" show-overflow-tooltip/>
      <el-table-column prop="laborCosts" label="工时费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="reportCosts" label="报告费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="totalCosts" label="总费用" align="center" show-overflow-tooltip/>
      <el-table-column prop="note" label="备注" show-overflow-tooltip/>
      <el-table-column prop="repairStatus" label="维修状态" align="center" show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.repairStatus" placeholder="维修状态" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="repairDate"
          label="维修日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="expiredDeliveryDate"
          label="预计发货日期"
          align="center"
          width="90px"
          show-overflow-tooltip/>
      <el-table-column
          prop="newMachineSn"
          label="新条码号"
          width="160px"
          align="center"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.newMachineSn" placeholder="新条码号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="newMaterialNo"
          label="新物料号"
          align="center"
          show-overflow-tooltip>
        <template #header>
          <el-input v-model.trim="filter.newMaterialNo" placeholder="新物料号" clearable @change="$refs.vmTable.handleSearchClick()"/>
        </template>
      </el-table-column>
      <el-table-column prop="newMaterialName" label="新物料描述" show-overflow-tooltip/>
      <el-table-column prop="attachmentNote" label="附件备注" show-overflow-tooltip/>
      <el-table-column prop="createTime" label="创建时间" align="center" width="140px"/>
      <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="80px">
        <template v-slot="scope">
          <el-button type="success" @click="onSelect(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </el-dialog>
</template>

<script>

  import VmSearchDate from "@/components/VmSearchDate.vue";

  export default {
    name: "RepairRegistrationSelect",
    components: {VmSearchDate},
    data() {
      return {
        dialogVisible: false,
        filter: {
          billNo: "",
          status: "",
          creatorName: "",
          afterSaleType: "",
          afterSaleOrderNo: "",
          afterSaleOrderNos: "",
          qualityRegistrationNo: "",
          department: "",
          demandNode: "",
          partType: "",
          customerName: "",
          outCustomerName: "",
          customerOrderNo: "",
          demandSn: "",
          demandMaterialNo: "",
          receiveSn: "",
          receiveMaterialNo: "",
          model: "",
          moduleBranding: "",
          originPartSn: "",
          partSn: "",
          partModel: "",
          componentMaterialNo: "",
          repairStatus: "",
          startTime: "",
          endTime: "",
          expiredDeliveryDateStart: "",
          expiredDeliveryDateEnd: "",
          newMachineSn: "",
          newMaterialNo: "",
          reported: "",
        },
      };
    },
    methods: {
      open() {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.vmTable.getList(1);
        });
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      onSelect(row) {
        this.$emit("select", row);
        this.dialogVisible = false;
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
